import React, { useState, useEffect } from "react";
import * as R from "ramda";
import { useParams, useNavigate, Link } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { EyeOutlined } from "@ant-design/icons";
import {
  BoxArrowUpRight,
  SortUp,
  SortDown,
  Display,
} from "react-bootstrap-icons";
import { getCustomer } from "../bowlers/bowlers.redux";
import { ArsenalCard, ContainerMod as ArsenalContainerMod } from "../ui/ArsenalCard";
import { BowlerHeader, HeaderActionButton } from "../ui/BowlerHeader";
import { validateValue } from "../../utils/utils";
import {
  setLoadBalls,
  ballSelect,
  ballRemove,
  ballAddNew,
  ballHandleForm,
  setArsenalFilter,
} from "../arsenal/arsenal.redux";
import styled, { css } from "styled-components";
import oneColumn from "../../images/List_View.png";
import oneColumnSelected from "../../images/List_View_Selected.png";
import twoColumns from "../../images/2C_Thumbnail_View.png";
import twoColumnsSelected from "../../images/2C_Thumbnail_View_Selected.png";
import threeColumns from "../../images/3C_Thumbnail_View.png";
import threeColumnsSelected from "../../images/3C_Thumbnail_View_Selected.png";
import spreader_bar from "../../images/spreader_bar.png";
import filter_Icon from "../../images/dashboard/Filter_Icon.png";
import searchIcon from "../../images/magnifying_glass_solid.svg";
import { Select } from "antd";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Spinner from "../ui/Spinner";
import { idx_data_ball_manufacturer } from "../db/datafixtures/datafixtures";
import { woocommerceCheckUserExists } from "../plugins/plugin.redux";
const CardDeckArsenalContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  padding: 0;

  @media only screen and (min-width: 768px) and (orientation: portrait) {
    ${ArsenalContainerMod} {
      width: 48%;
      min-width: 48%;
    }
  }

  ${(props) =>
    props.portrait &&
    css`
      display: none;
    `}
`;

const Marginrules = styled.div`
  margin: 16px 6vw 20vh;
  width: 100%;
  max-width: 1024px;

  @media only screen and (max-width: 768px) {
    max-width: 84vw;
  }
`;

const MenuStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  background-color: #ffffff;
  width: 100%;
  z-index: 999;
  top: 0;

  @media only screen and (max-width: 991px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
`;

const FloatingLabelOrderBy = styled(FloatingLabel)`
  & label {
    color: #00297a !important;
    transform: scale(0.65) translateY(-1rem) translateX(0.15rem);
  }

  font: normal normal bold 20px / 28px Lato;
  letter-spacing: 0px;
  opacity: 1;
  font-weight: 700;
  order: 1;
  flex: 5;
`;

const SelectOrderArsenal = styled(Select)`
  width: 100%;
  height: 48px;

  & .ant-select-selector {
    height: 48px !important;
  }

  & .ant-select-arrow {
  }

  &.arsenal-select .ant-select-selector {
    overflow: auto;
    padding-top: 2px;
  }

  &.arsenal-select .ant-select-selector .ant-select-selection-item {
    line-height: 48px !important;
  }

  &.arsenal-select
    .ant-select-selector
    .ant-select-selection-overflow-item
    .ant-select-selection-item {
    line-height: 24px !important;
  }
`;

const SelectArsenal = styled(Select)`
  width: 100%;
  height: 48px;

  & .ant-select-selector {
    height: 48px !important;
  }

  & .ant-select-arrow {
  }

  &.arsenal-select .ant-select-selector {
    overflow: auto;
    padding-top: 15px;
  }

  &.arsenal-select .ant-select-selector .ant-select-selection-item {
    line-height: 48px !important;
  }

  &.arsenal-select
    .ant-select-selector
    .ant-select-selection-overflow-item
    .ant-select-selection-item {
    line-height: 24px !important;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.reverse ? "row-reverse" : "row")};
  align-items: center;
  justify-content: center;
`;

const DisplayContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

const DisplayLabel = styled.div`
  font: normal normal bold 10px Lato;
  text-align: center;
`;
const SelectStyle = styled.div`
  margin-right: 20px;

  @media only screen and (max-width: 450px) and (orientation: portrait) {
    margin-right: 0;
    margin-bottom: 0.5em;
  }

  @media only screen and (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 0.5em;
  }
`;

const ButtonViewStyles = styled.div`
  text-align: end;
  order: 6;

  @media only screen and (max-width: 768px) {
    display: none;
    max-width: 84vw;
  }

  @media only screen and (max-width: 1200px) and (orientation: portrait) {
    display: none;
    max-width: 84vw;
  }
  @media only screen and (max-width: 450px) and (orientation: portrait) {
    display: none;
  }
`;

const FilterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;

  @media only screen and (max-width: 1200px) {
    justify-content: center;
  }
`;

const Button = styled.button`
  display: inline-block;
  margin: 0.5rem 0;
  padding: 0;
  width: 52px;
  height: 55px;
  background: transparent;
  border: none;
  text-align: center;
  vertical-align: middle;

  ${(props) =>
    props.add &&
    css`
      background: #00becc 0% 0% no-repeat padding-box;
      border-radius: 4px;
      margin-top: 7px;
      opacity: 1;
      width: 145px;
      height: 48px;
      font-weight: 500;

      @media only screen and (max-width: 768px) {
        display: none;
      }

      @media only screen and (max-width: 900px) and (orientation: portrait) {
        display: none;
      }
      @media only screen and (max-width: 450px) and (orientation: portrait) {
        display: none;
      }
    `}

  ${(props) =>
    props.sort &&
    css`
      border-radius: 4px;
      margin-top: 7px;
      opacity: 1;
      font-weight: 500;
      flex: 1;
    `}
`;

const textStyles = {
  color: "#00197B",
  background: "transparent",
  border: "transparent",
  letterSpacing: "0.07px",
  fontWeight: "700",
  order: 5,
  padding: 0,
};

const Image = styled.img`
  width: 18px;
  height: 18px;
  background: none;
  text-align: center;
  vertical-align: middle;
`;

const IconEye = styled.div`
  border-radius: 50%;
  background: #00147b80 0% 0% no-repeat padding-box;
  color: #ffffff;
  width: 28px;
  height: 28px;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
const titleStyle = {
  font: "normal normal bold 28px / 36px Lato",
  letterSpacing: "0px",
  color: "#000000",
  opacity: "1",
  fontWeight: "700",
  order: 1,
};
const customerNameStyle = {
  font: "normal normal bold 20px / 28px Lato",
  letterSpacing: "0px",
  color: "#000000",
  opacity: "1",
  fontWeight: "700",
  order: 1,
};
const marginStyle = {
  marginTop: "20px",
  marginBottom: "50px",
  display: "flex",
  flexWrap: "wrap",
  columnGap: "14px",
  width: "100%",
};
const thumbnailStyle = {
  width: "18px",
  height: "18px",
};
const spreaderBarStyle = {
  width: "2px",
  height: "18px",
};

const search_container = {
  width: "100%",
  height: "37px",
  fontWeight: "700",
  letterSpacing: "2px",
  fontSize: "12px",
  margin: "1rem auto",
  border: "1px solid #D4D4D5",
  borderRadius: "100px",
  backgroundImage: `url(${searchIcon})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right 5% center",
  backgroundSize: "16px",
};
const orderSearch = {
  display: "flex",
  flexDirection: "column",
  order: 3,
};
const borderContainer = {
  width: "100%",
  minWidth: "250px",
  height: "180px",
  marginTop: "1vh",
  background: "var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box",
  border: "1px solid var(--unnamed-color-d4d4d5)",
  background: "#FFFFFF 0% 0% no-repeat padding-box",
  border: "1px solid #D4D4D5",
  borderRadius: "4px",
  opacity: "1",
  display: "flex",
  alignContent: "center",
  justifyContent: "center",
  alignItems: "center",
};

export const ArsenalRedux = (props) => {
  const { t } = useTranslation();
  const params = useParams();
  const bowlerID = params.bowlerID;

  const {
    balls_drilled_before_filter,
    originalBallsDrilled,
    userId,
    arsenal_layout_style,
    state,
    getCustomer,
    loadingBalls,
    initialValues,
    loadingCustomer,
    setLoadBalls,
    ballRemove,
    ballAddNew,
    ballHandleForm,
    selectedCustomer,
    setArsenalFilter,
    filter,
    ballSelect,
    isReadOnly,
    woocommerceCheckUserExists,
    pluginSubscriptions,
  } = props;
  const navigate = useNavigate();
  const [show, setShow] = useState("three");
  const [showFilter, setShowFilter] = useState(true);
  const [temporalFilters, setTemporalFilters] = useState("");
  const [temporalOrderByField, setTemporalOrderByField] =
    useState("date_drilled");
  const [temporalOrderDirection, setTemporalOrderDirection] = useState("desc");

  // Here we set the filters for the balls
  let balls_drilled = !R.isEmpty(temporalFilters)
    ? balls_drilled_before_filter.filter(
        (ball) => R.indexOf(ball.manufacturer)(temporalFilters) >= 0
      )
    : balls_drilled_before_filter;

  balls_drilled = R.sortWith([
    temporalOrderDirection === "asc"
      ? R.ascend(R.prop(temporalOrderByField))
      : R.descend(R.prop(temporalOrderByField)),
  ])(balls_drilled);

  // Here we set the order for the balls

  useEffect(() => {
    if (!selectedCustomer) {
      getCustomer({ customer_id: bowlerID });
    }
  }, [selectedCustomer]);

  const handleFilter = (filter) => {
    setTemporalFilters(filter);
  };

  const handleOrderBy = (field) => {
    setTemporalOrderByField(field);
  };

  const handleOrderByDirection = (direction) => {
    setTemporalOrderDirection(direction);
  };

  const handleAddBall = (e) => {
    ballAddNew({});
  };

  const handleViewChange = (e) => {
    if (validateValue(e.target.value) !== "") {
      setShow(e.target.value);
    } else if (validateValue(e.target.id) !== "") {
      setShow(e.target.id);
    }
  };

  return loadingCustomer && balls_drilled.length === 0 ? (
    <Spinner />
  ) : (
    <>
      <BowlerHeader
        actions={
          !isReadOnly && (
            <HeaderActionButton onClick={handleAddBall}>
              {t("form.label.add_ball")}
            </HeaderActionButton>
          )
        }
      />
    <Marginrules>
      <MenuStyle>
        {showFilter && (
          <FilterContainer className="col-12 col-md-12 col-lg-9">
            <SelectStyle className="col-12 col-md-3 col-lg-3">
              <ButtonContainer reverse>
                <FloatingLabelOrderBy
                  label={t("order by")}
                  className="arsenal-select-floating-label"
                >
                  <SelectOrderArsenal
                    className="arsenal-select"
                    value={temporalOrderByField}
                    options={[
                      {
                        value: "date_drilled",
                        label: t("Date drilled"),
                        active: temporalOrderByField === "date_drilled",
                      },
                      {
                        value: "ball_name",
                        label: t("ball-name"),
                        active: temporalOrderByField === "ball_name",
                      },
                      {
                        value: "surface",
                        label: t("Surface"),
                        active: temporalOrderByField === "surface",
                      },
                    ]}
                    onChange={handleOrderBy}
                  />
                </FloatingLabelOrderBy>
                <Button
                  sort
                  onClick={() => {
                    if (temporalOrderDirection === "asc") {
                      handleOrderByDirection("desc");
                    } else {
                      handleOrderByDirection("asc");
                    }
                  }}
                >
                  {temporalOrderDirection === "asc" ? (
                    <SortUp style={{ fontSize: 24, color: "#00297a" }} />
                  ) : (
                    <SortDown style={{ fontSize: 24, color: "#00297a" }} />
                  )}
                </Button>
              </ButtonContainer>
            </SelectStyle>
            <SelectStyle className="col-12 col-md-3 col-lg-3">
              <ButtonContainer reverse>
                <FloatingLabelOrderBy
                  label={t("Brands")}
                  className="arsenal-select-floating-label"
                >
                  <SelectArsenal
                    className="arsenal-select"
                    mode="multiple"
                    allowClear
                    options={idx_data_ball_manufacturer.map(
                      (manufacturerData) => ({
                        value: manufacturerData.manufacturer,
                        label: manufacturerData.manufacturer,
                      })
                    )}
                    onChange={handleFilter}
                  />
                </FloatingLabelOrderBy>
                <DisplayContainer>
                  <Button
                    sort
                    onClick={() => {
                      if (filter === "all") {
                        setArsenalFilter({ filter: "active" });
                      } else if (filter === "active") {
                        setArsenalFilter({ filter: "inactive" });
                      } else {
                        setArsenalFilter({ filter: "all" });
                      }
                    }}
                  >
                    <IconEye>
                      <EyeOutlined style={{ fontSize: 16 }} />
                    </IconEye>
                  </Button>
                  <DisplayLabel>{t(`form.label.show_${filter}`)}</DisplayLabel>
                </DisplayContainer>
              </ButtonContainer>
            </SelectStyle>

            <ButtonViewStyles className="col-4 col-md-2 col-lg-2">
              <Button
                onClick={handleViewChange}
                value="three"
                active={show === "three" ? true : false}
              >
                <Image
                  src={show === "three" ? threeColumnsSelected : threeColumns}
                  alt="email logo"
                  id="three"
                />
              </Button>
              <img style={spreaderBarStyle} src={spreader_bar} alt="bar logo" />
              <Button
                onClick={handleViewChange}
                value="two"
                active={show === "two" ? true : false}
              >
                <Image
                  style={thumbnailStyle}
                  src={show === "two" ? twoColumnsSelected : twoColumns}
                  alt="email logo"
                  id="two"
                />
              </Button>
            </ButtonViewStyles>
          </FilterContainer>
        )}
      </MenuStyle>
      <CardDeckArsenalContainer>
        <div style={marginStyle}>
          {originalBallsDrilled?.length === 0 ? (
            <div style={borderContainer}>
              {!isReadOnly && (
                <Button add className="btn btn-primary" onClick={handleAddBall}>
                  {t("form.label.add_ball")}
                </Button>
              )}
            </div>
          ) : (
            balls_drilled?.map((arsenal, index) => (
              <ArsenalCard
                name={`${arsenal.manufacturer || ""} ${
                  arsenal.ball_name || ""
                }`}
                serial_number={arsenal.serial_number}
                layout={arsenal.layout}
                layout_type={arsenal.layout_type}
                arsenal_layout_style={arsenal_layout_style}
                surface_preparation={arsenal.surface_preparation}
                ball_enable={arsenal.enable}
                date={arsenal.updated_at}
                userId={userId}
                photo={arsenal.photo}
                id={arsenal.id}
                showActions={true}
                bowlerID={bowlerID}
                view={show}
                ballRemove={ballRemove}
                ballHandleForm={ballHandleForm}
                ball={arsenal}
                ballSelect={ballSelect}
                isReadOnly={isReadOnly}
                selectedCustomer={selectedCustomer}
                woocommerceCheckUserExists={woocommerceCheckUserExists}
                pluginSubscriptions={pluginSubscriptions}
              />
            ))
          )}
        </div>
      </CardDeckArsenalContainer>
    </Marginrules>
    </>
  );
};

const setBallLayout = (currentLayout) => (ball) => {
  const layout = ball.layout ? ball.layout.split(" X ") : [];

  switch (currentLayout) {
    case "dual_angle":
      return {
        ...ball,
        drilling_angle: layout.length > 0 ? layout[0] : null,
        pin_to_pap: layout.length > 1 ? layout[1] : null,
        val_angle: layout.length > 2 ? layout[2] : null,
      };
    case "vls":
      return {
        ...ball,
        pin_to_pap: layout.length > 0 ? layout[0] : null,
        psa_to_pap: layout.length > 1 ? layout[1] : null,
        pin_buffer: layout.length > 2 ? layout[2] : null,
      };
    case "none":
    default:
      return ball;
  }
};

export const ArsenalScreen = connect(
  (state) => {
    const filter = state.balls.filter;
    const originalBallsDrilled =
      state.bowlers.selectedCustomer?.balls_drilled || [];
    return {
      loadingCustomer: state.bowlers.loadingCustomer,
      arsenal_layout_style:
        state.settings.appSettings.layoutPreferences.arsenal_layout_style,
      loadingBalls: state.balls.loading,
      balls_drilled_before_filter:
        filter === "all"
          ? originalBallsDrilled
          : filter === "active"
          ? originalBallsDrilled.filter((ball) => ball.enable === true)
          : originalBallsDrilled.filter((ball) => ball.enable !== true),
      originalBallsDrilled,
      state: state,
      userId: state.userSession.userData.id,
      initialValues: setBallLayout(
        state.settings.appSettings.layoutPreferences.arsenal_layout_style
      )(state.balls.ball),
      selectedCustomer: state.bowlers.selectedCustomer,
      isReadOnly: state.userSession.isReadOnly,
      pluginSubscriptions: state.plugin.pluginSubscriptions,
      filter,
    };
  },
  {
    getCustomer,
    setLoadBalls,
    ballSelect,
    ballRemove,
    ballAddNew,
    ballHandleForm,
    setArsenalFilter,
    woocommerceCheckUserExists,
  }
)(ArsenalRedux);
